import { useCallback } from 'react';
import type { MultiselectProps } from '@amzn/awsui-components-core/multiselect';
import type { TokenGroupProps } from '@amzn/awsui-components-core/token-group';
import type { StudioOption } from 'src/components/star-grid/reportStudio.types';
import { useStarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import { studioMultiselectPresentation, studioSelectionValues } from 'src/components/star-grid/utils/studioMultiselect';

export const useStudioMultiselect = (values: readonly string[], options: readonly StudioOption[], onChange: (values: readonly string[]) => void) => {
  const text = useStarGridText();
  const change: NonNullable<MultiselectProps['onChange']> = useCallback(
    ({ detail }) => onChange(studioSelectionValues(detail.selectedOptions)),
    [onChange]
  );
  const dismiss: NonNullable<TokenGroupProps['onDismiss']> = useCallback(
    ({ detail }) => onChange(values.filter((_, index) => index !== detail.itemIndex)),
    [onChange, values]
  );
  return { text, ...studioMultiselectPresentation(values, options, text), onChange: change, onDismiss: dismiss };
};
